var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('div',{staticClass:"card pb-5"},[_c('div',{staticClass:"title text-center",staticStyle:{"margin-top":"80px"}},[_c('h2',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }